/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builds_Comparison_Nextpage1Inputs */

const id_builds_comparison_nextpage1 = /** @type {(inputs: Builds_Comparison_Nextpage1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Halaman berikutnya`)
};

const ms_builds_comparison_nextpage1 = /** @type {(inputs: Builds_Comparison_Nextpage1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Halaman seterusnya`)
};

const da_builds_comparison_nextpage1 = /** @type {(inputs: Builds_Comparison_Nextpage1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Næste side`)
};

const de_builds_comparison_nextpage1 = /** @type {(inputs: Builds_Comparison_Nextpage1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nächste Seite`)
};

const en_us2_builds_comparison_nextpage1 = /** @type {(inputs: Builds_Comparison_Nextpage1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Next page`)
};

const es_es2_builds_comparison_nextpage1 = /** @type {(inputs: Builds_Comparison_Nextpage1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Página siguiente`)
};

const es_mx2_builds_comparison_nextpage1 = /** @type {(inputs: Builds_Comparison_Nextpage1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Página siguiente`)
};

const fil_builds_comparison_nextpage1 = /** @type {(inputs: Builds_Comparison_Nextpage1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Susunod na pahina`)
};

const fr_builds_comparison_nextpage1 = /** @type {(inputs: Builds_Comparison_Nextpage1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Page suivante`)
};

const it_builds_comparison_nextpage1 = /** @type {(inputs: Builds_Comparison_Nextpage1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pagina successiva`)
};

const hu_builds_comparison_nextpage1 = /** @type {(inputs: Builds_Comparison_Nextpage1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Következő oldal`)
};

const nl_builds_comparison_nextpage1 = /** @type {(inputs: Builds_Comparison_Nextpage1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volgende pagina`)
};

const no_builds_comparison_nextpage1 = /** @type {(inputs: Builds_Comparison_Nextpage1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neste side`)
};

const pl_builds_comparison_nextpage1 = /** @type {(inputs: Builds_Comparison_Nextpage1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Następna strona`)
};

const pt_br2_builds_comparison_nextpage1 = /** @type {(inputs: Builds_Comparison_Nextpage1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Próxima página`)
};

const pt_builds_comparison_nextpage1 = /** @type {(inputs: Builds_Comparison_Nextpage1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Página seguinte`)
};

const ro_builds_comparison_nextpage1 = /** @type {(inputs: Builds_Comparison_Nextpage1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pagina următoare`)
};

const fi_builds_comparison_nextpage1 = /** @type {(inputs: Builds_Comparison_Nextpage1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seuraava sivu`)
};

const sv_builds_comparison_nextpage1 = /** @type {(inputs: Builds_Comparison_Nextpage1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nästa sida`)
};

const vi_builds_comparison_nextpage1 = /** @type {(inputs: Builds_Comparison_Nextpage1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trang tiếp theo`)
};

const tr_builds_comparison_nextpage1 = /** @type {(inputs: Builds_Comparison_Nextpage1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sonraki sayfa`)
};

const cs_builds_comparison_nextpage1 = /** @type {(inputs: Builds_Comparison_Nextpage1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Další stránka`)
};

const bg_builds_comparison_nextpage1 = /** @type {(inputs: Builds_Comparison_Nextpage1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Следваща страница`)
};

const ru_builds_comparison_nextpage1 = /** @type {(inputs: Builds_Comparison_Nextpage1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Следующая страница`)
};

const uk_builds_comparison_nextpage1 = /** @type {(inputs: Builds_Comparison_Nextpage1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Наступна сторінка`)
};

const ar_builds_comparison_nextpage1 = /** @type {(inputs: Builds_Comparison_Nextpage1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الصفحة التالية`)
};

const hi_builds_comparison_nextpage1 = /** @type {(inputs: Builds_Comparison_Nextpage1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अगला पृष्ठ`)
};

const th_builds_comparison_nextpage1 = /** @type {(inputs: Builds_Comparison_Nextpage1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`หน้าถัดไป`)
};

const ja_builds_comparison_nextpage1 = /** @type {(inputs: Builds_Comparison_Nextpage1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`次のページ`)
};

const zh_cn2_builds_comparison_nextpage1 = /** @type {(inputs: Builds_Comparison_Nextpage1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`下一页`)
};

const zh_hant1_builds_comparison_nextpage1 = /** @type {(inputs: Builds_Comparison_Nextpage1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`下一頁`)
};

const ko_builds_comparison_nextpage1 = /** @type {(inputs: Builds_Comparison_Nextpage1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`다음 페이지`)
};

/**
* | output |
* | --- |
* | "Next page" |
*
* @param {Builds_Comparison_Nextpage1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const builds_comparison_nextpage1 = /** @type {((inputs?: Builds_Comparison_Nextpage1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builds_Comparison_Nextpage1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_builds_comparison_nextpage1(inputs)
	if (locale === "ms") return ms_builds_comparison_nextpage1(inputs)
	if (locale === "da") return da_builds_comparison_nextpage1(inputs)
	if (locale === "de") return de_builds_comparison_nextpage1(inputs)
	if (locale === "en-US") return en_us2_builds_comparison_nextpage1(inputs)
	if (locale === "es-ES") return es_es2_builds_comparison_nextpage1(inputs)
	if (locale === "es-MX") return es_mx2_builds_comparison_nextpage1(inputs)
	if (locale === "fil") return fil_builds_comparison_nextpage1(inputs)
	if (locale === "fr") return fr_builds_comparison_nextpage1(inputs)
	if (locale === "it") return it_builds_comparison_nextpage1(inputs)
	if (locale === "hu") return hu_builds_comparison_nextpage1(inputs)
	if (locale === "nl") return nl_builds_comparison_nextpage1(inputs)
	if (locale === "no") return no_builds_comparison_nextpage1(inputs)
	if (locale === "pl") return pl_builds_comparison_nextpage1(inputs)
	if (locale === "pt-BR") return pt_br2_builds_comparison_nextpage1(inputs)
	if (locale === "pt") return pt_builds_comparison_nextpage1(inputs)
	if (locale === "ro") return ro_builds_comparison_nextpage1(inputs)
	if (locale === "fi") return fi_builds_comparison_nextpage1(inputs)
	if (locale === "sv") return sv_builds_comparison_nextpage1(inputs)
	if (locale === "vi") return vi_builds_comparison_nextpage1(inputs)
	if (locale === "tr") return tr_builds_comparison_nextpage1(inputs)
	if (locale === "cs") return cs_builds_comparison_nextpage1(inputs)
	if (locale === "bg") return bg_builds_comparison_nextpage1(inputs)
	if (locale === "ru") return ru_builds_comparison_nextpage1(inputs)
	if (locale === "uk") return uk_builds_comparison_nextpage1(inputs)
	if (locale === "ar") return ar_builds_comparison_nextpage1(inputs)
	if (locale === "hi") return hi_builds_comparison_nextpage1(inputs)
	if (locale === "th") return th_builds_comparison_nextpage1(inputs)
	if (locale === "ja") return ja_builds_comparison_nextpage1(inputs)
	if (locale === "zh-CN") return zh_cn2_builds_comparison_nextpage1(inputs)
	if (locale === "zh-Hant") return zh_hant1_builds_comparison_nextpage1(inputs)
	return ko_builds_comparison_nextpage1(inputs)
});
export { builds_comparison_nextpage1 as "builds.comparison.nextPage" }